import React, { useEffect, useState } from 'react';
import {
  Alert, Box, CircularProgress, Typography,
} from '@mui/material';
import { fetchGabbaiMessages } from '../gabbaiPortalApi';
import { getGabbaiTheme } from '../gabbaiPortalTheme';
import { formatHebrewDate } from '../../../utils/hebrewDate';

function formatDate(d) {
  return formatHebrewDate(d);
}

export default function MessagesScreen() {
  const t = getGabbaiTheme();
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError('');
      try {
        const data = await fetchGabbaiMessages();
        if (!cancelled) setMessages(data.data || []);
      } catch (err) {
        if (!cancelled) setError(err.response?.data?.error || 'שגיאה בטעינת ההודעות');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'grid', placeItems: 'center', py: 6 }}>
        <CircularProgress sx={{ color: t.accent }} />
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 640, mx: 'auto' }}>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {!error && !messages.length && (
        <Alert severity="info" sx={{ borderRadius: 2 }}>
          אין הודעות פעילות כרגע
        </Alert>
      )}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {messages.map((m) => (
          <Box
            key={m.id}
            sx={{
              border: `1px solid ${t.cardBorder}`,
              background: t.cardBg,
              borderRadius: 2.5,
              px: 2.25,
              py: 2,
            }}
          >
            <Typography sx={{ color: '#f5f0e6', fontWeight: 700, fontSize: '1.05rem', mb: 0.75 }}>
              {m.title}
            </Typography>
            {m.body && (
              <Typography sx={{ color: 'rgba(245,240,230,0.78)', whiteSpace: 'pre-wrap', mb: 1 }}>
                {m.body}
              </Typography>
            )}
            {m.audioUrl && (
              <Box sx={{ mb: 1 }}>
                <audio controls src={m.audioUrl} style={{ width: '100%' }}>
                  <track kind="captions" />
                </audio>
              </Box>
            )}
            <Typography sx={{ color: 'rgba(245,240,230,0.45)', fontSize: '0.8rem' }}>
              בתוקף עד {formatDate(m.validTo)}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
